import { useEffectOnce } from 'hook/useEffectOnce'
import { makeAutoObservable } from 'mobx'
import { mx } from 'store/base/mx'
import { InferenceStore } from 'store/inference/InferenceStore'
import ProfileStore from 'store/profile/ProfileStore'
import { store } from 'store/store'
import { IdentityMode } from 'type/Identity'

export class MeasurementsBannerStore {
  readonly profile: ProfileStore

  constructor(profile: ProfileStore) {
    this.profile = profile
    makeAutoObservable(this)
  }
}

export const measurements_banner = mx.ref<MeasurementsBannerStore>()

export function useMeasurementsBanner() {
  useEffectOnce(() => {
    return () => measurements_banner.close()
  })
}

export function openMeasurementsBanner(profile: ProfileStore, inference?: InferenceStore) {
  if (inference) {
    profile.form.setMode(IdentityMode.DETAILED)
    store.identities.activateProfile(profile)
  }
  measurements_banner.open(new MeasurementsBannerStore(profile))
}
